module.exports = __webpack_public_path__ + "img/index-button-ZJ_02@2x.4e7cc4f0.png";